import { Currency } from "../constants/general-basic-data";

export class StringData {
	
	data: string;

	constructor(data: string){
		this.data=data;
	}
}

export class Price {	
	amount: number;
	currency: Currency;
	date: number;

	constructor(amount: number, currency: Currency, date: number){

		this.amount = amount;
		this.currency = currency;
		this.date = (date === 0) ? Date.now() : date;
	}

	static getDefault(): Price{
		return new Price(0, Currency.XOF, 0);
	}
}

export interface Offer {	
	
	amount: number;
	buyerId: string;
	created: number;
	lastUpdated: number;

	status: string;
}

export class ImageFolder {	
	carId: string = '';
	blobs: any[] = [];


	constructor(carId: string, blob?: Blob){
		this.carId = carId;
		if(blob)
			this.blobs = [blob]
	}
}


